import React from 'react';
import {
  CheckCircle,
  Cancel,
  HourglassEmpty,
  Done,
} from '@mui/icons-material';

const StatusBadge = ({ status }) => {
  let bgColor = '';
  let textColor = '';
  let icon = null;
  let label = '';

  switch (status) {
    case 'confirmed':
      bgColor = 'bg-green-100';
      textColor = 'text-green-800';
      icon = <CheckCircle className="w-4 h-4 text-green-500 mr-1" />;
      label = 'Confirmée';
      break;
    case 'cancelled':
      bgColor = 'bg-red-100';
      textColor = 'text-red-800';
      icon = <Cancel className="w-4 h-4 text-red-500 mr-1" />;
      label = 'Annulée';
      break;
    case 'completed':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-800';
      icon = <Done className="w-4 h-4 text-blue-500 mr-1" />;
      label = 'Terminée';
      break;
    case 'pending':
    default:
      bgColor = 'bg-yellow-100';
      textColor = 'text-yellow-800';
      icon = <HourglassEmpty className="w-4 h-4 text-yellow-500 mr-1" />;
      label = 'En attente';
      break;
  }

  return (
    <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
      {icon}
      {label}
    </div>
  );
};

export default StatusBadge;
